/*
 * Copyright (c) Funtip GbR 2017.
 * Simon Oldeboershuis, Perry Prust
 */

import * as React from 'react';
import { Team } from '../../services/betting';
import { TeamLink } from '../TeamLink';
import { GameResult } from '../TournamentApp/GameResult';

interface GameMiniProps {
    gameId: string;
    team1: Team;
    team2: Team;
}

export class GameMini extends React.PureComponent<GameMiniProps> {
    render() {
        return (
            <span>
                <TeamLink teamId={this.props.team1.id} displayType="mini" />
                <span style={{ letterSpacing: '-1px' }}>&nbsp;-&nbsp;</span>
                <TeamLink teamId={this.props.team2.id} displayType="mini" />
                <br />
                <GameResult gameId={this.props.gameId} />
            </span>
        );
    }
}
